/* eslint-disable indent */
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import HrNav from "./hrNav/HrNav";

const LeftNav = () => {
  const { currentUser } = useSelector((state) => state.auth);

  const showLogo = () => {
    return (
      <Link
        to={`/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`}
        className="logo text-center"
      >
        <span className="logo-lg">
          <img
            alt=""
            src="https://i.imgur.com/ahvlkuu.png"
            // src=""
            height="30"
          />
        </span>
      </Link>
    );
  };

  return (
    <div
      className="left-side-menu bg-dark "
      style={{
        height: "100%",
        position: "fixed",
        padding: "0px",
        background:
          "linear-gradient(to top, rgba(255,255,255,0.10) 0%, rgba(0,0,0,0.5) 100%), radial-gradient(at top center, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.40) 120%)"
      }}
    >
      <div
        className="slimscroll-menu"
        style={{
          overflowY: "auto",
          height: "95%",
          position: "relative"
        }}
      >
        {showLogo()}

        <HrNav currentUser={currentUser} />
      </div>
    </div>
  );
};

export default LeftNav;
